import React from "react";
import { useForm, useFormContext } from "react-hook-form";
import InputField from "../../../common/components/FormFields/InputField";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import { format } from "date-fns";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import DatePickerField from "../../../common/components/FormFields/DatePickerField";

function UsgSonography(props) {
  const defaultValues = {
    gaByDate: "",
  };

  const { control, watch, setValue, reset, handleSubmit } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
  });

  const [
    dateWatch,
    gestureAgeWatch,
    fetalPositionWatch,
    fetalHeartWatch,
    liquorWatch,
    placentaWatch,
    dopplerWatch,
  ] = watch([
    "date",
    "gestureAge",
    "fetalPosition",
    "fetalHeart",
    "liquor",
    "placenta",
    "doppler",
  ]);

  const onSubmitData = (data) => {
    let dataObject = {
      date: format(dateWatch, "yyyy-MM-dd"),
      gaByDate: formatWeeksDays(calculateGADays(dateWatch)),
      "GA By Date": formatWeeksDays(calculateGADays(dateWatch)),
      "Gestational Age (USG)": gestureAgeWatch,
      gestureAge: gestureAgeWatch,
      fetalPosition: fetalPositionWatch,
      "Fetal Position": fetalPositionWatch,
      fetalHeart: fetalHeartWatch,
      "Fetal Heart": fetalHeartWatch,
      liquor: liquorWatch,
      placenta: placentaWatch,
      doppler: dopplerWatch,
    };

    let dataArray = [...props?.usgSonographyDetails];
    dataArray.push(dataObject);

    props?.setUsgSonographyDetails(dataArray);

    setValue("date", new Date());
    setValue("gestureAge", "");
    setValue("fetalPosition", "");
    setValue("fetalHeart", "");
    setValue("liquor", "");
    setValue("placenta", "");
    setValue("doppler", "");
    setValue("doppler", "");
    setValue("gaByDate", "");
  };

  function calculateGADays() {
    const today = dateWatch;

    const diffMs = today - props?.lmpDate;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    return diffDays + 1;
  }

  function formatWeeksDays(totalDays) {
    const weeks = Math.floor(totalDays / 7);
    const days = totalDays % 7;

    if (days === 0) {
      return `${weeks} Weeks`;
    } else {
      return `${weeks} Weeks , ${days} Days`;
    }
  }

  React.useEffect(() => {
    console.log("dateWatchdateWatchdateWatchdateWatchdateWatch", dateWatch);

    if (dateWatch !== null && dateWatch !== undefined) {
      if (props?.lmpDate !== null && props?.lmpDate !== undefined) {
        setValue("gaByDate", formatWeeksDays(calculateGADays(dateWatch)));
      } else {
        setValue("gaByDate", "");
      }
    }
  }, [dateWatch, props?.lmpDate]);

  return (
    <form className="mb-2 ">
      <div className="flex justify-between bg-[#ece4f5] rounded-t-md mb-2">
        <div className="">
          <p className="text-sm font-semibold pl-2 py-1">USG Sonography</p>
        </div>
      </div>
      <div className="flex gap-2 items-center">
        <div className="w-[95%]">
          <div className="grid grid-cols-8 gap-2 items-center px-2">
            <div className="mt-1">
              <DatePickerField
                control={control}
                name={"date"}
                label={"Date"}
                inputFormat={"dd/MM/yyyy"}
              />
            </div>
            <div className="mt-1">
              <InputField
                control={control}
                name={"gaByDate"}
                label={"GA By Date"}
              />
            </div>
            <div className="mt-1">
              <InputField
                control={control}
                name={"gestureAge"}
                label={"Gestational Age (USG)"}
              />
            </div>
            <div className="items-center">
              <InputField
                control={control}
                name={"fetalPosition"}
                label={"Fetal Position"}
              />
            </div>
            <div className="items-center">
              <InputField
                control={control}
                name={"fetalHeart"}
                label={"Fetal Heart"}
              />
            </div>

            <div>
              <InputField control={control} name={"liquor"} label={"Liquor"} />
            </div>
            <div>
              <InputField
                control={control}
                name={"placenta"}
                label={"Placenta"}
              />
            </div>
            <div>
              <InputField
                control={control}
                name={"doppler"}
                label={"Doppler"}
              />
            </div>
          </div>
        </div>
        <div className="w-[5%]">
          <CommonButton
            label={"Add"}
            className={"px-3 rounded border border-customBlue text-customBlue"}
            type={"submit"}
            onClick={handleSubmit(onSubmitData)}
          />
        </div>
      </div>
    </form>
  );
}

export default UsgSonography;

